"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminClientsComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL BITS
const admin_service_1 = require("./admin.service");
const user_service_1 = require("./user.service");
const clients_service_1 = require("./clients.service");
const permission_service_1 = require("./permission.service");
const notification_service_1 = require("./notification.service");
const integration_service_1 = require("./integration.service");
const _ = require("lodash");
let AdminClientsComponent = class AdminClientsComponent {
    constructor(_talk, _admin, _cd, _clients, _user, _permission, _integration) {
        this._talk = _talk;
        this._admin = _admin;
        this._cd = _cd;
        this._clients = _clients;
        this._user = _user;
        this._permission = _permission;
        this._integration = _integration;
        this.defaultCols = 0;
        this.clientModel = { name: "", organization: "", integration: 1 };
        this.MIN_TIMEOUT = 100;
        this.MAX_TIMEOUT = 60000;
        this.PERMITTED_COLS = [
            "static-timeout",
            "min-timeout",
            "max-timeout",
            "fast-bandwidth",
            "slow-bandwidth",
            "ad-unit-hard-floor"
        ];
    }
    ngOnInit() {
        Promise.resolve((this.permission = this._permission.get())).then(err => {
            this.defaultCols =
                this.PERMITTED_COLS.length +
                    ~~this.permission["control_center-line_item_automation"] +
                    ~~this.permission["control_center-integrations--gpt_instant_load"] +
                    ~~this.permission["control_center-integrations--enable_services"] +
                    ~~this.permission["control_center-integrations--internal_refresh"] +
                    ~~this.permission["control_center-integrations--pub_cid"] +
                    ~~this.permission["control_center-integrations--holistic_resequencer"] +
                    ~~this.permission["control_center-integrations--dynamic_ad_unit_targetinig"] +
                    ~~this.permission["control_center-integrations--dynamic_ad_unit_targetinig"] +
                    ~~this.permission["control-center-que-refresh"] +
                    ~~this.permission["control_center-integrations--target_div_and_code"] +
                    ~~this.permission["control_center-integrations--target_div_and_code"] +
                    ~~this.permission["control_center-integrations--instant_auction"] +
                    ~~this.permission["control_center-integrations--wait_for_slot_defintion"] +
                    ~~this.permission["control_center-integrations--guarenteed_refresh"] +
                    ~~this.permission["control_center-integrations--immedate_fire_pixel"] +
                    ~~this.permission["control_center-integrations--refresh_option"] +
                    ~~this.permission["control-center-new-unit-generation"] +
                    ~~this.permission["control_center-integrations--cast_t_as_integer"] +
                    ~~this.permission["control_center-integrations--enforce_gdpr_demand_partners"] +
                    ~~this.permission["control_center-integrations--enforce_tcf2_demand_partners"] +
                    ~~this.permission["control_center-integrations--enforce_ccpa_demand_partners"];
        });
        this.clients = this._clients.get();
    }
    createClient(clientToCreate) {
        clientToCreate.name = clientToCreate.name.trim();
        if (this.clients.filter(r => {
            return r.name.toLowerCase() == clientToCreate.name.toLowerCase();
        }).length > 0) {
            return this._talk.broadcast(`Oops! It looks like an organization with this name already exists <i class="fa fa-smile-o" aria-hidden="true"></i>`);
        }
        if (clientToCreate.name.length == 0) {
            return this._talk.broadcast(`Client name cannot be kept blank. <i class="fa fa-smile-o" aria-hidden="true"></i>`);
        }
        clientToCreate.organization = this._user.get().organization.id;
        Promise.resolve(this._admin.createClient(clientToCreate)).then(success => {
            clientToCreate.name = "";
            Promise.resolve(this._clients.pull()).then(err => {
                this.clients = this._clients.get();
                this.clientModel = { name: "", organization: "", integration: 1 };
            });
        }, fail => {
            this._talk.broadcast(`There was a problem creating that client: <br>` + fail);
        });
    }
    backToClient(pos, client) {
        //get back to the client row after cancel or save changes
        let clientData = _.cloneDeep(this._clients.get());
        let filteredClient = _.filter(clientData, function (currentClient) { return currentClient.id === client.id; });
        this.clients[pos] = _.cloneDeep(filteredClient[0]);
    }
    saveClientChanges(pos, client) {
        new Promise((resolve, reject) => {
            let changes = false;
            let pastIntegration = this._integration.getIntegration(client.integration.id);
            client.domains = client.domainList
                .map(val => {
                return val.name;
            })
                .join(", ")
                .toLowerCase();
            Object.keys(pastIntegration).forEach((key, index) => {
                if (key != "createdAt" || "updatedAt") {
                    if (pastIntegration[key] != client.integration[key]) {
                        changes = true;
                    }
                }
            });
            if (changes) {
                let errors = "";
                if (this.validTimeoutRange(client.integration.minTimeout, client.integration.maxTimeout)) {
                    let staticTimeout = this.sanitizeTimeout(client.integration.staticTimeout, "static");
                    let minTimeout = this.sanitizeTimeout(client.integration.minTimeout, "min");
                    let maxTimeout = this.sanitizeTimeout(client.integration.maxTimeout, "max");
                    client.integration.staticTimeout = staticTimeout.value;
                    client.integration.minTimeout = minTimeout.value;
                    client.integration.maxTimeout = maxTimeout.value;
                    errors += staticTimeout.error + minTimeout.error + maxTimeout.error;
                }
                else {
                    errors += `<li>Max timeout must be greater than min timeout</li>`;
                }
                if (errors.length > 0) {
                    this._talk.broadcast(errors);
                    resolve(true);
                }
                else if (client.integration.id == 1) {
                    Promise.resolve(this._admin.createIntegration(client.integration, client.name)).then(err => {
                        client.integration.id = err;
                        resolve(true);
                    });
                }
                else {
                    Promise.resolve(this._admin.updateIntegration(client.integration)).then(err => {
                        resolve(true);
                    });
                }
            }
            else {
                resolve(true);
            }
        }).then(err => {
            Promise.resolve(this._admin.updateClient({
                id: client.id,
                name: client.name,
                integration: client.integration.id,
                domains: client.domains
            })).then(err => {
                Promise.resolve(this._integration.pull()).then(err => {
                    Promise.resolve(this._clients.pull().then(err => {
                        this.backToClient(pos, client);
                        this._cd.markForCheck();
                    }));
                });
            }, fail => {
                this._talk.broadcast(`There was a problem updating that user: <br>` + fail);
            });
        });
    }
    validTimeoutRange(minTimeout, maxTimeout) {
        return maxTimeout > minTimeout;
    }
    sanitizeTimeout(timeout, timeoutType) {
        let error = "";
        if (timeout < this.MIN_TIMEOUT) {
            error =
                `<li>Timeouts have a minimum of ` +
                    this.MIN_TIMEOUT +
                    `ms. Your value of ` +
                    timeout +
                    ` for ` +
                    timeoutType +
                    `ms timeout has been updated to ` +
                    this.MIN_TIMEOUT +
                    `ms</li>`;
            return { value: this.MIN_TIMEOUT, error: error };
        }
        else if (timeout > this.MAX_TIMEOUT) {
            error =
                `<li>Timeouts have a maximum of ` +
                    this.MAX_TIMEOUT +
                    `ms. Your value of ` +
                    timeout +
                    ` for ` +
                    timeoutType +
                    `ms timeout has been updated to ` +
                    this.MAX_TIMEOUT +
                    `ms</li>`;
            return { value: this.MAX_TIMEOUT, error: error };
        }
        else {
            return { value: timeout, error: error };
        }
    }
    editClient(client) {
        if (client.domains && client.domains.length > 0)
            client.domainList = client.domains.split(", ").map(val => {
                return { name: val };
            });
        else
            client.domainList = [];
    }
    removeWhiteList(client, domain) {
        client.domainList = client.domainList.filter(val => {
            return val.name != domain.name;
        });
    }
    cancelClientEdit(pos, client) {
        this.backToClient(pos, client);
    }
    gptInstantLoadHelp() {
        this._clients.gptInstantLoadHelp();
    }
    enableServicesHelp() {
        this._clients.enableServicesHelp();
    }
    internalRefreshHelp() {
        this._clients.internalRefreshHelp();
    }
    pubCommonIdHelp() {
        this._clients.pubCommonIdHelp();
    }
    holisticResequencerHelp() {
        this._clients.holisticResequencerHelp();
    }
    dynamicAdUnitTargetingHelp() {
        this._clients.dynamicAdUnitTargetingHelp();
    }
    dynamicAdUnitTargetingFallbackHelp() {
        this._clients.dynamicAdUnitTargetingFallbackHelp();
    }
    targetAdUnitDivIDHelp() {
        this._clients.targetAdUnitDivIDHelp();
    }
    targetAdUnitCodeHelp() {
        this._clients.targetAdUnitCodeHelp();
    }
    instantAuctionHelp() {
        this._clients.instantAuctionHelp();
    }
    waitForSlotDefinitionHelp() {
        this._clients.waitForSlotDefinitionHelp();
    }
    guaranteedRefreshHelp() {
        this._clients.guaranteedRefreshHelp();
    }
    immediateFirePixelHelp() {
        this._clients.immediateFirePixelHelp();
    }
    refreshOptionHelp() {
        this._clients.refreshOptionHelp();
    }
    newUnitGenerationHelp() {
        this._clients.newUnitGenerationHelp();
    }
    castTAsIntegerHelp() {
        this._clients.castTAsIntegerHelp();
    }
    enforceGDPRDemandPartnersHelp() {
        this._clients.enforceGDPRDemandPartnersHelp();
    }
    enforceCCPADemandPartnersHelp() {
        this._clients.enforceCCPADemandPartnersHelp();
    }
    enforceTCF2DemandPartnersHelp() {
        this._clients.enforceTCF2DemandPartnersHelp();
    }
};
exports.AdminClientsComponent = AdminClientsComponent;
exports.AdminClientsComponent = AdminClientsComponent = __decorate([
    (0, core_1.Component)({
        selector: "admin-clients",
        templateUrl: "app/admin-clients.component.html",
        styleUrls: ["styles/admin.component.css"]
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        admin_service_1.AdminService,
        core_1.ChangeDetectorRef,
        clients_service_1.ClientsService,
        user_service_1.UserService,
        permission_service_1.PermissionService,
        integration_service_1.IntegrationService])
], AdminClientsComponent);
//# sourceMappingURL=admin-clients.component.js.map